import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Navigate } from "react-router-dom";

import {
  getEncuestas,
  setFormulario,
  setPreguntaActiva,
  getUsuario,
  setAnswer,
} from "../actions";

import { Container, Row, Col, Button, ListGroup } from "react-bootstrap";

import logo1 from "../img/cmdic-forta-05.png";
import logo2 from "../img/cmdic-forta-02.png";
import logo3 from "../img/cmdic-forta-03.png";
import logo4 from "../img/cmdic-forta-04.png";
import logo5 from "../img/cmdic-forta-04.png";
import logo6 from "../img/cmdic-forta-03.png";
import logo7 from "../img/cmdic-forta-02.png";
import logo8 from "../img/cmdic-forta-05.png";
import { ReactComponent as Icono1 } from "../img/check-circle.svg";
import { ReactComponent as Icono2 } from "../img/hourglass.svg";

const Inicio = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const usuario = useSelector((state) => state.usuario);

  const respuestas = JSON.parse(usuario.Detail);
  //console.log("usuario.Detail", respuestas);

  const [values, setValues] = useState({
    respuesta1: respuestas.Survey11101,
    respuesta2: respuestas.Survey11102,
    respuesta3: respuestas.Survey11103,
    respuesta4: respuestas.Survey11104,
    respuesta5: respuestas.Survey11105,
    respuesta6: respuestas.Survey11106,
    respuesta7: respuestas.Survey11107,
    respuesta8: respuestas.Survey11108,
  });

  const preguntaActiva = useSelector((state) => state.preguntaActiva);

  const handleClick = (props) => {
    /*  dispatch(
      setPreguntaActiva({
        id_instrumento: props.id_instrumento,
        id_pregunta: props.id_pregunta,
        contador: 1,
      })
    ); */
  };

  //console.log(
  //     "Usuario",
  //     usuario.Detail,
  //     usuario.Detail.replace("\\", ""),
  //     JSON.parse(usuario.Detail.replace("\\", "")),
  //     JSON.parse(usuario.Detail)
  // );

  //if (preguntaActiva.id_instrumento !== 0)
  //  return <Navigate to="/pregunta" replac="true" />;

  const Boton = (props) => {
    //console.log("props", props);
    const _d = props.datos;
    if (_d.respuestas >= _d.total) {
      return (
        <div className="mt-auto">
          <p className="mt-4 xz-texto-v text-center">
            <span className="">Actividad Terminada</span>
          </p>
          <div className="text-center">
            <Icono1 fill="#003e00" width="45px" height="45px" />
          </div>
        </div>
      );
    } else
      return (
        <div className="mt-auto text-center">
          <div className="mb-4">
            <Icono2 fill="#003e00" width="30px" height="45px" />
            <span className="xz-texto-v">{_d.minutos} min</span>
          </div>
          <a
            href="#"
            className="btn btn-primary btn-verde mt-auto align-self-start"
            onClick={handleClick.bind(this, {
              id_instrumento: _d.id_instrumento,
              id_pregunta: _d.id_pregunta,
            })}
          >
            Iniciar
          </a>{" "}
        </div>
      );
  };

  const HandleClickVolver = (props) => {
    //console.log("Click", props);
    const _valor = values[props.variable] === 1 ? 0 : 1;
    const _questionId = props.questionId;
    // Guardar Pregunta en Base de Datos
    const _props = {
      Token: "c3649ba4e3a81815",
      Function: "SetSurveyAnswer",
      Parameters: {
        Id: 0,
        CreationDateTime: "",
        UserId: parseInt(usuario.UserId.split("-")[0]),
        SurveyId: 111,
        QuestionId: _questionId,
        Answer: _valor,
        Value: 0,
      },
    };

    //dispatch(setAnswer(_props));

    //Reducer
    /*setValues((values) => ({
      ...values,
      [props.variable]: _valor,
    }));*/
  };

  const boton11 =
    values.respuesta1 === 1
      ? "xz-btn-redondo-6 xz-btn-redondo-6-seleccionado"
      : "xz-btn-redondo-6 ";
  const boton12 =
    values.respuesta2 === 1
      ? "xz-btn-redondo-6 xz-btn-redondo-6-seleccionado"
      : "xz-btn-redondo-6 ";
  const boton13 =
    values.respuesta3 === 1
      ? "xz-btn-redondo-6 xz-btn-redondo-6-seleccionado"
      : "xz-btn-redondo-6 ";
  const boton14 =
    values.respuesta4 === 1
      ? "xz-btn-redondo-6 xz-btn-redondo-6-seleccionado"
      : "xz-btn-redondo-6 ";

  const boton21 =
    values.respuesta5 === 1
      ? "xz-btn-redondo-6 xz-btn-redondo-6-seleccionado"
      : "xz-btn-redondo-6";
  const boton22 =
    values.respuesta6 === 1
      ? "xz-btn-redondo-6 xz-btn-redondo-6-seleccionado"
      : "xz-btn-redondo-6 ";
  const boton23 =
    values.respuesta7 === 1
      ? "xz-btn-redondo-6 xz-btn-redondo-6-seleccionado"
      : "xz-btn-redondo-6 ";
  const boton24 =
    values.respuesta8 === 1
      ? "xz-btn-redondo-6 xz-btn-redondo-6-seleccionado"
      : "xz-btn-redondo-6 ";

  return (
    <Container>
      <Row>
        <Col className="mt-4 text-center">
          <p className="h3 ">
            {" "}
            Muchas gracias por participar en la Identificación de Fortalezas del
            Rol SPS en Collahuasi
          </p>
        </Col>
      </Row>

      <Row className="m-sm-5">
        <Col className="xz-texto-v">
          <p>
            En los próximos días recibirás un correo electrónico con el
            resultado de las Fortalezas identificadas en ti.
          </p>
          <p>
            Este resultado, será enviado confidencialmente desde GaudÍPersonas a
            tu correo.
          </p>
        </Col>
      </Row>

      <Row className="">
        <Col className="xz-col-xs text-center">
          {" "}
          <Button
            className={boton11}
            onClick={HandleClickVolver.bind(this, {
              variable: "respuesta1",
              questionId: 11101,
              valor: 1,
            })}
          ></Button>
        </Col>
        <Col className="xz-col-xs text-center">
          {" "}
          <Button
            className={boton12}
            onClick={HandleClickVolver.bind(this, {
              variable: "respuesta2",
              questionId: 11102,
              valor: 1,
            })}
          ></Button>{" "}
        </Col>
        <Col className="xz-col-xs text-center">
          {" "}
          <Button
            className={boton13}
            onClick={HandleClickVolver.bind(this, {
              variable: "respuesta3",
              questionId: 11103,
              valor: 1,
            })}
          ></Button>
        </Col>
        <Col className="xz-col-xs text-center">
          {" "}
          <Button
            className={boton14}
            onClick={HandleClickVolver.bind(this, {
              variable: "respuesta4",
              questionId: 11104,
              valor: 1,
            })}
          ></Button>
        </Col>
      </Row>
      <Row>
        <Col className="xz-col-xs text-center">
          <p>Autorregulación </p>
          <p className="xz-texto-sm ">No se deja llevar por los impulsos</p>
        </Col>
        <Col className="xz-col-xs text-center">
          Persistencia
          <p className="xz-texto-sm ">
            Termina la tarea a pesar de los obstáculos
          </p>
        </Col>
        <Col className="xz-col-xs text-center">
          Inteligencia Social y Personal{" "}
          <p className="xz-texto-sm ">
            Voluntad de interactuar, comunicarse y colaborar
          </p>
        </Col>
        <Col className="xz-col-xs text-center">
          <p>Inteligencia Talento </p>
          <p className="xz-texto-sm ">
            Facilidad natural e interés por aprender
          </p>
        </Col>
      </Row>
      <Row>
        <Col className="xz-col-xs text-center">
          {" "}
          <Button
            className={boton21}
            onClick={HandleClickVolver.bind(this, {
              variable: "respuesta5",
              questionId: 11105,
              valor: 1,
            })}
          ></Button>
        </Col>
        <Col className="xz-col-xs text-center">
          {" "}
          <Button
            className={boton22}
            onClick={HandleClickVolver.bind(this, {
              variable: "respuesta6",
              questionId: 11106,
              valor: 1,
            })}
          ></Button>{" "}
        </Col>
        <Col className="xz-col-xs text-center">
          {" "}
          <Button
            className={boton23}
            onClick={HandleClickVolver.bind(this, {
              variable: "respuesta7",
              questionId: 11107,
              valor: 1,
            })}
          ></Button>
        </Col>
        <Col className="xz-col-xs text-center">
          {" "}
          <Button
            className={boton24}
            onClick={HandleClickVolver.bind(this, {
              variable: "respuesta8",
              questionId: 11108,
              valor: 1,
            })}
          ></Button>
        </Col>
      </Row>
      <Row>
        <Col className="text-center mb-t">
          <p className="xz-col-xs ">Disposición Digital </p>
          <p className="xz-texto-sm ">
            Actitud propositiva hacia el uso de tecnología
          </p>
        </Col>
        <Col className="xz-col-xs text-center">
          <p>Excelencia </p>
          <p className="xz-texto-sm ">
            Se orienta a una gestión sobresaliente y prudente
          </p>
        </Col>
        <Col className="xz-col-xs text-center">
          <p>Diversidad</p>
          <p className="xz-texto-sm ">Apreciar el valor de la diferencia</p>
        </Col>
        <Col className="xz-col-xs text-center">
          <p>Apertura a los cambios </p>
          <p className="xz-texto-sm ">Flexibilidad y valoración por lo nuevo</p>
        </Col>
      </Row>
      <h6></h6>
      <div className="mb-4">
        <p className="mb-3 h4">Vamos a los tests </p>
      </div>
      <Row className="mb-3">
        <Col className="col-12 col-md-6 col-lg-3 mb-5 d-flex align-items-stretch">
          <div className="card">
            <img src={logo1} className="card-img-top" alt="..." />
            <div className="card-body d-flex flex-column">
              <h5 className="card-title xz-texto-i">1</h5>
              <Boton
                datos={{
                  id_instrumento: 101,
                  id_pregunta: 10101,
                  total: 37,
                  minutos: "7",
                  respuestas: respuestas.Survey101,
                }}
              />{" "}
            </div>
          </div>
        </Col>
        <Col className="col-12 col-md-6 col-lg-3 mb-5 d-flex align-items-stretch">
          <div className="card">
            <img src={logo2} className="card-img-top" alt="..." />
            <div className="card-body d-flex flex-column">
              <h5 className="card-title xz-texto-i">2</h5>
              <Boton
                datos={{
                  id_instrumento: 102,
                  id_pregunta: 10201,
                  total: 30,
                  minutos: "6",
                  respuestas: respuestas.Survey102,
                }}
              />
            </div>
          </div>
        </Col>

        <Col className="col-12 col-md-6 col-lg-3 mb-5 d-flex align-items-stretch">
          <div className="card">
            <img src={logo3} className="card-img-top" alt="..." />
            <div className="card-body  d-flex flex-column">
              <h5 className="card-title xz-texto-i">3</h5>
              <Boton
                datos={{
                  id_instrumento: 103,
                  id_pregunta: 10301,
                  total: 50,
                  minutos: "10",
                  respuestas: respuestas.Survey103,
                }}
              />
            </div>
          </div>
        </Col>
        <Col className="col-12 col-md-6 col-lg-3 mb-5 d-flex align-items-stretch">
          <div className="card">
            <img src={logo4} className="card-img-top" alt="..." />
            <div className="card-body  d-flex flex-column">
              <h5 className="card-title xz-texto-i">4</h5>
              <Boton
                datos={{
                  id_instrumento: 104,
                  id_pregunta: 10401,
                  total: 36,
                  minutos: "7",
                  respuestas: respuestas.Survey104,
                }}
              />
            </div>
          </div>
        </Col>
        <Col className="col-12 col-md-6 col-lg-3 mb-5  d-flex align-items-stretch">
          <div className="card">
            <img src={logo5} className="card-img-top" alt="..." />
            <div className="card-body d-flex flex-column">
              <h5 className="card-title xz-texto-i">5</h5>
              <Boton
                datos={{
                  id_instrumento: 105,
                  id_pregunta: 10501,
                  total: 34,
                  minutos: "6",
                  respuestas: respuestas.Survey105,
                }}
              />
            </div>
          </div>
        </Col>
        <Col className="col-12 col-md-6 col-lg-3 mb-5  d-flex align-items-stretch">
          <div className="card">
            <img src={logo6} className="card-img-top" alt="..." />
            <div className="card-body d-flex flex-column">
              <h5 className="card-title xz-texto-i">6</h5>
              <Boton
                datos={{
                  id_instrumento: 106,
                  id_pregunta: 10601,
                  total: 41,
                  minutos: "8",
                  respuestas: respuestas.Survey106,
                }}
              />
            </div>
          </div>
        </Col>
        <Col className="col-12 col-md-6 col-lg-3 mb-5  d-flex align-items-stretch">
          <div className="card">
            <img src={logo7} className="card-img-top" alt="..." />
            <div className="card-body d-flex flex-column">
              <h5 className="card-title xz-texto-i">7</h5>
              <Boton
                datos={{
                  id_instrumento: 107,
                  id_pregunta: 10701,
                  total: 33,
                  minutos: "6",
                  respuestas: respuestas.Survey107,
                }}
              />
            </div>
          </div>
        </Col>
        <Col className="col-12 col-md-6 col-lg-3 mb-5 d-flex align-items-stretch">
          <div className="card">
            <img src={logo8} className="card-img-top" alt="..." />
            <div className="card-body d-flex flex-column">
              <h5 className="card-title xz-texto-i">8</h5>
              <Boton
                datos={{
                  id_instrumento: 108,
                  id_pregunta: 10801,
                  total: 43,
                  minutos: "7",
                  respuestas: respuestas.Survey108,
                }}
              />
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Inicio;
